import { apiClient } from './apiClient';

const createUser = async (data) => {
  return await apiClient.post_form('/register', data);
};

const loginUser = async (data) => {
  return await apiClient.post_form('/login', data);
};

const recoveryPassword = async (data) => {
  return await apiClient.post_form('/recovery_password', data);
};

const confirmEmail = async (id, data) => {
  return await apiClient.get(`/email/confirmation/${id}`, data);
};

const updatePassword = async (id, data) => {
  return await apiClient.post_form(`/email/confirmation/${id}/update`, data);
};

const logout = async (data) => {
  return await apiClient.post_form('/logout', data);
};

export const authApi = {
  createUser,
  loginUser,
  recoveryPassword,
  confirmEmail,
  updatePassword,
  logout,
};
